module.exports = __webpack_public_path__ + "img/4.8c20f543.png";